<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    let activeItem = null;

    function setActive(item) {
        if (activeItem?.index === item.index) {
            activeItem.close();
            activeItem = null;
        } else {
            if (activeItem !== null)
                activeItem.close();
            activeItem = item;
            activeItem.open();
        }
    }

</script>

<slot {setActive}/>
